import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type ImageLightboxProps = {
  alt: string;
  description?: string;
  emptyMessage?: string;
  imageUrl: string | null;
  onImageError?: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  title?: string;
};

export function ImageLightbox({
  alt,
  description,
  emptyMessage,
  imageUrl,
  onImageError,
  onOpenChange,
  open,
  title = alt,
}: ImageLightboxProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="w-[min(96vw,74rem)] gap-5 border-[#eadcc7] bg-[#f5f1e8] p-5 text-ink shadow-[0_30px_90px_-35px_rgba(25,20,12,0.32)]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? (
            <DialogDescription className="text-ink/70">{description}</DialogDescription>
          ) : null}
        </DialogHeader>
        {imageUrl ? (
          <div className="overflow-hidden rounded-[28px] border border-[#e3d7c9] bg-[#ede4d6]">
            <img
              alt={alt}
              className="max-h-[78vh] w-full object-contain"
              onError={onImageError}
              src={imageUrl}
            />
          </div>
        ) : (
          <div className="flex min-h-48 items-center justify-center rounded-[28px] border border-dashed border-[#d7cab9] bg-[#efe6d8] px-6 text-center text-sm text-ink/70">
            {emptyMessage ?? alt}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
